import { useState } from "react";

export const useDialogState = () => {
  const [openAdd, setOpenAdd] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleClickOpenAdd = (e) => {
    e.stopPropagation();
    setOpenAdd(true);
  };

  const handleCloseAdd = () => {
    setOpenAdd(false);
  };

  const handleClickOpenUpdate = (e, row) => {
    e.stopPropagation();
    setSelectedRow(row);
    setOpenUpdate(true);
  };

  const handleCloseUpdate = () => {
    setOpenUpdate(false);
    setSelectedRow(null);
  };

  const handleClickOpenDelete = (e, row) => {
    e.stopPropagation();
    setSelectedRow(row);
    setOpenDelete(true);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setSelectedRow(null);
  };

  return {
    // Dialog states
    openAdd,
    openUpdate,
    openDelete,
    selectedRow,

    // Handlers
    handleClickOpenAdd,
    handleCloseAdd,
    handleClickOpenUpdate,
    handleCloseUpdate,
    handleClickOpenDelete,
    handleCloseDelete,
  };
};
